import { Environment, getEnvironment } from '@color/lib';
import { reactQueryClient, v4ReactQueryClient } from '@color/lib/Api';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools as ReactQueryDevtoolsV4 } from '@tanstack/react-query-devtools';
import { PropsWithChildren } from 'react';
import { QueryClientProvider as LegacyQueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

const { REACT_APP_ENABLE_REACT_QUERY_DEVTOOLS } = process.env;

export const AppQueryClientProvider: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;
  return (
    /**
     * The dev tools should not be included in the production bundle at all and render null, but
     * let's be extra safe and only render them in the local environment.
     *
     * Note: initialIsOpen only tracks the initial open, and the user choice is persisted to localstorage.
     * After it is in local storage, the previous state is used instead of closing the dev tools on refresh.
     */
    <LegacyQueryClientProvider client={reactQueryClient}>
      <QueryClientProvider client={v4ReactQueryClient}>
        {children}
        {getEnvironment() === Environment.LOCAL && REACT_APP_ENABLE_REACT_QUERY_DEVTOOLS && (
          <>
            <ReactQueryDevtools initialIsOpen={false} />
            <ReactQueryDevtoolsV4 initialIsOpen={false} />
          </>
        )}
      </QueryClientProvider>
    </LegacyQueryClientProvider>
  );
};
